<template>
  <div>
    <div class="">
      <v-alert
        dense
        border="left"
        type="warning"
        dismissible
        v-if="exampleFileData[0].need_to_show_message"
      >
        <span v-html="exampleFileData[0].message"></span>
      </v-alert>
    </div>
    <div class="px-6">
      <div class="" v-if="!isClient">
        <v-autocomplete
          clearable
          dense
          outlined
          v-model="formData.client"
          :items="clients"
          item-text="text"
          item-value="index"
          :placeholder="$t('choose_client')"
          :error-messages="clientErrors"
          @input="$v.formData.client.$touch()"
          @blur="$v.formData.client.$touch()"
        ></v-autocomplete>
      </div>
      <div class="row">
        <div class="col-12 col-sm-8 col-md-9">
          <v-file-input
            v-model="formData.file"
            clearable
            ref="file_uploader"
            :label="$t('file_input')"
            outlined
            dense
            required
            :error-messages="fileErrors"
            @input="$v.formData.file.$touch()"
            @blur="$v.formData.file.$touch()"
          ></v-file-input>
        </div>
        <div class="col-12 col-sm-4 col-md-3 text-center">
          <v-btn class="primary--text" outlined text :href="exampleFileData">
            {{ $t("download_template") }}
          </v-btn>
        </div>
      </div>
    </div>
    <div class="mb-4 d-flex flex-grow-1 align-end justify-center mt-4">
      <button
        type="reset"
        class="btn btn-light me-3 px-5 py-3 ls1"
        @click="resetForm"
      >
        {{ $t("clear") }}
      </button>
      <button
        type="submit"
        class="btn btn-info px-5 py-3 ls1"
        @click="submitForm"
      >
        {{ $t("upload") }}
      </button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
export default {
  name: "ProductForm",
  mixins: [validationMixin],
  validations() {
    return {
      formData: {
        file: { required },
        client: {
          required: requiredIf(function () {
            return !this.isClient;
          }),
        },
      },
    };
  },
  props: {
    importTypeData: {
      required: true,
      type: Object,
    },
    submit: {
      required: true,
      type: Function,
    },
  },
  data: () => ({
    formData: {
      client: null,
      file: null,
    },
  }),
  computed: {
    isClient() {
      return !(this.$store.getters.currentUser.data.user_type == "admin");
    },
    clients: function () {
      return this.importTypeData.data.customers;
    },
    exampleFileData: function () {
      const sample = this.importTypeData.data.files[0].url;
      return sample;
    },
    clientErrors() {
      return this.handleFormValidation("client", this);
    },
    fileErrors() {
      return this.handleFormValidation("file", this);
    },
  },
  methods: {
    handleFormValidation(fieldName, vueObj) {
      const errors = [];
      if (!vueObj.$v.formData[fieldName].$dirty) return errors;

      if ("required" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      return errors;
    },
    submitForm() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      let data = new FormData();
      data.append("file", this.formData.file, this.formData.file.name);
      data.append("type", this.importTypeData.type);
      if (!this.isClient) {
        data.append("customer_id", this.formData.client);
      }
      const success = this.submit(data);
      if (success) {
        this.$nextTick(() => {
          this.resetForm();
        });
      } else {
        return;
      }
    },
    resetForm() {
      this.formData = {
        client: null,
        file: null,
      };
    },
  },
};
</script>

<style></style>
